const mobileFilterBtn = document.querySelector(".mobile__filter-dropdown__button");
const filterContainer = document.querySelector(".filter-dropdowns");

export default function init() {
  mobileFilterBtn.addEventListener('click', () => {
    filterContainer.style.transform = "translate(0px)";
  })
}